(ns frontend.view.modals.review.view
  (:require
   [ui.components.modal.view :as modal]))

(defonce modal-key :review-modal)

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [title-text button-text footer-text value on-submit!]} props]
    [modal/view
     {:visible?      (and shown? topmost?)
      :hide!         close-modal!
      :backdrop      "static"
      :close-button? true}
     title-text
     value
     [:<>
      [:div
       {:class "flex gap-3 items-center"}
       footer-text]
      [modal/right-single-button
       nil
       false
       close-modal!
       button-text
       nil]]]))
